import {required, sameAs} from 'vuelidate/lib/validators'
import zxcvbn from 'zxcvbn'

const minPasswordScore = 2;

export default {
  validations: {
    password: {
      required,
      strength: v => zxcvbn(v).score >= minPasswordScore
    },
    password_confirmation: {
      required,
      sameAsPassword: sameAs('password')
    },
  },
  data() {
    return {
      minPasswordScore,
      password: '',
      password_confirmation: '',
      showPassword: false,
      submitted: false,
    }
  },
  methods: {
    passwordErrors() {
      const errors = []
      if (! this.$v.password.$dirty) return errors
      if (! this.$v.password.strength) {
        errors.push('Password strength must be "Medium" or stronger.')
      }
      return errors
    },
    passwordConfirmationErrors() {
      const errors = []
      if (! this.$v.password_confirmation.$dirty) return errors
      ! this.$v.password_confirmation.required && errors.push('Password confirmation is required')
      ! this.$v.password_confirmation.sameAsPassword && errors.push('Passwords do not match')
      return errors
    },
  },
  computed: {
    score() {
      const result = zxcvbn(this.password);

      switch (result.score) {
        case 4:
          return {
            color: "light-blue",
            text: "Very Strong",
            value: 100
          };
        case 3:
          return {
            color: "light-green",
            text: "Strong",
            value: 75
          };
        case 2:
          return {
            color: "yellow",
            text: "Medium",
            value: 50
          };
        case 1:
          return {
            color: "orange",
            text: "Weak",
            value: 25
          };
        default:
          return {
            color: "red",
            text: "Very Weak",
            value: 0
          };
      }
    }
  }
}